<template>
    <section>
        <barra-titulo
            titulo="Manifestos"
            icone="fa fa-road"
            :itens="breadCrumb"
        />
        <lista />
    </section>
</template>
<script>
import Lista from '@/modules/mdfe/domains/mdfe/manifestos/components/Lista'
export default {
    name: 'ListaMdfe',
    components: {
        Lista
    },
    data() {
        return {
            breadCrumb: [
                {
                    descricao: 'MDF-e',
                    url: this.$urlBase + '/manifestos'
                },
                {
                    descricao: 'Listar'
                }
            ],
        }
    }
}
</script>
